import React from 'react';
import Lazyload from 'react-lazyload';
import './index.css';
import {Webp} from '../../formateImage';
import Detector from '../../../../utils/detector';
export default class IntroductionStation extends React.Component {
  render(){
    let { className, needShowMore, stationList,title, type, showMore } = this.props;
    if(!stationList || !stationList.length) 
      return null;

    return (
      <div className={className ? `introduction-station ${className}` : 'introduction-station'}>
        <h4>下一站{title}</h4>
        {
          needShowMore ? 
            <div className={`station-more ${Detector.os.name}`} onClick={()=>{
              showMore(type);
            }}>
            更多{title}
              <i className="icon icon-arrow"></i>
            </div> : null
        }
        <ul className="station-list">
          {
            stationList.map((item, index) =>{
              return <Item
                key={index}
                item={item}
                hanldeItemClick={this.hanldeItemClick} />;
            })
          }
        </ul>
      </div>
    );
  }
  
  hanldeItemClick = (item)=>{
    this.props.handleClickNextStation(item);
  }
}

function Item(props){
  let { item, hanldeItemClick } = props;
  let image = `${item.pic_url}!/both/210x160` || 'https://imgcdn50.zuzuche.com/m_tantu_image/20171101/5d1cb7232871f5ccba3258b98f0871fe.jpg!/both/210x160';
  image = Webp(image);
  return (
    <li className="station-item" onClick={()=>{
      hanldeItemClick(item);
    }}>
      <div className="image">
        <Lazyload>
          <img src={image} alt=""/>
        </Lazyload>
        <div className="tag"><span>{item.line_distance}</span></div>
      </div>
      <h5>{item.cn_name}</h5>
      {item.percent > 0 ? <p className="detail"><b>{item.percent}%</b>的人会去</p> : null}
    </li>
  );
}







// WEBPACK FOOTER //
// ./src/components/Poi2/Introduction/Station/index.js